import { render, staticRenderFns } from "./ProfessorEvaluationsCourse.vue?vue&type=template&id=42a5cdc0"
import script from "./ProfessorEvaluationsCourse.vue?vue&type=script&lang=js"
export * from "./ProfessorEvaluationsCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports